import { ReactElement, ReactNode } from 'react';
import type { SmartOption } from '../../../types';
import { MicroBadgeContainer, MicroBadgeValue } from 'components/MicroBadge';
import { smartLabelColors } from 'styles/colors';

const symbols = {
  RATE: '%',
  UNIT: '×',
} as const;

export function Label({ index, rate, application, direction }: Omit<SmartOption, 'naive'>): ReactElement {
  const symbol = application ? symbols[application] : '';

  let value: ReactNode = <MicroBadgeValue>—{symbol}</MicroBadgeValue>;
  switch (direction) {
    case 'CLIENT':
      value = (
        <MicroBadgeValue style={{ background: smartLabelColors.CLIENT[index % 3] }}>
          {rate.client || '—'}
          {symbol}
        </MicroBadgeValue>
      );
      break;
    case 'AGENCY':
      value = (
        <MicroBadgeValue style={{ background: smartLabelColors.AGENCY[index % 3] }}>
          {rate.provider || '—'}
          {symbol}
        </MicroBadgeValue>
      );
      break;
    case 'BOTH':
      value = (
        <>
          <MicroBadgeValue style={{ background: smartLabelColors.CLIENT[index % 3] }}>
            {rate.client || '—'}
            {symbol}
          </MicroBadgeValue>
          <MicroBadgeValue style={{ background: smartLabelColors.AGENCY[index % 3] }}>
            {rate.provider || '—'}
            {symbol}
          </MicroBadgeValue>
        </>
      );
      break;
  }

  return <MicroBadgeContainer>{value}</MicroBadgeContainer>;
}
